import { UserTaskEntityType } from '@/shared/api-client/enums/user-task-entity-type';
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class UserTaskIconComponent extends Vue {

    @Prop() public entityType!: UserTaskEntityType;
    @Prop() public translations!: { [key: string]: string; };
}
